export default __webpack_public_path__ + "static/media/straightIcon.272e5fc8.svg";